import { z } from 'zod';

/*
 * Runtime schemas for the untyped notification-preference shim responses
 * (finding D / Group 2). Not in `openapi.json` yet (ADR 0009), so the transport
 * edge-parses before returning: a drift / empty body becomes a handled
 * retryable `ApiError`, not a `TypeError` in a toggle. Mirrors the
 * `NotificationPreferences` / `NotificationPreferenceChange` shapes in
 * `notification-preferences.ts`; deleted when the routes enter `openapi.json`.
 *
 * The four governed keys are stated as literals here (not imported from the
 * transport) to avoid a schema↔transport import cycle; they mirror
 * `NOTIFICATION_PREFERENCE_KEYS` exactly, both hand-authored against the same
 * governed registry.
 */

const PREFERENCE_KEYS = [
  'payment_due_reminder',
  'auto_debit_approaching',
  'auto_debit_posted',
  'auto_debit_returned_nsf',
] as const;

export const NotificationPreferencesSchema = z.object({
  payment_due_reminder: z.boolean(),
  auto_debit_approaching: z.boolean(),
  auto_debit_posted: z.boolean(),
  auto_debit_returned_nsf: z.boolean(),
});

const NotificationPreferenceChangeSchema = z.object({
  key: z.enum(PREFERENCE_KEYS),
  enabledBefore: z.boolean().nullable(),
  enabledAfter: z.boolean(),
  self: z.boolean(),
  changedByName: z.string().nullable(),
  changedAt: z.string(),
});

export const NotificationPreferenceHistorySchema = z.array(
  NotificationPreferenceChangeSchema,
);
